<template>
  <div class="serial">
    <!-- ヘッダー -->
    <SimpleHeader :productInfo="productInfo" />
    <div class="inner flexcenter">
      <div class="serial-controls flexcenter">
        <h3>シリアル番号を入力して利用開始</h3>
        <div class="serial-input flexcenter">
          <input class="serial-text" type="text" v-model.lazy="serial" placeholder="シリアル番号" maxlength="25"
            @input="validate($event)"
            @compositionstart="ignore = true"
            @compositionend="composition($event)"
            @keypress.enter="doActivate($event)">
          <button class="enter" @click="doActivate($event)"><img src="static/images/icon/svg/ar_r_login.svg" alt="enter"></button>
        </div>
        <p class="serial-error" v-if="message">{{ message }}</p>
        <p>
          <a class="serial-anchor" href="http://www.sourcenext.com/permission/104/" target="_blank">
            Rosetta Stone について
          </a>
        </p>
      </div><!-- /.serial-controls -->
    </div><!-- /.inner -->
  </div><!-- /.serial -->
</template>

<script>
import SimpleHeader from '@/components/Header'
import common from '@/mixin/common'
import http from '@/mixin/http'
import Json from '../../static/data.json'
import * as constants from '@/mixin/constants'

export default {
  name: 'serial',
  data: function() {
    return {
      serial: '',
      message: '',
      productInfo: Json.productInfo,
      ignore: false,
    }
  },
  components: {
    SimpleHeader,
  },
  mixins: [
    common,
    http,
  ],
  methods: {
    /**
     * シリアル入力処理実行
     *
     * @param {Object} event イベントオブジェクト
     */
    doActivate: function (event) {
      var self = this
      self.log("Serial start doActivate")

      // シリアル番号の先頭末尾の空白を除去
      self.serial = self.serial.trim()

      // 空文字の場合は、API実行しない
      if(self.serial.length == 0) {
        self.log("Serial end doActivate: input value empty")
        self.message = constants.ERR_INVALID_SERIAL
        return
      }

      // シリアル入力APIを実行
      self.activate(self.productInfo.code, self.getFormattedSerial())
        .then(function(response) {
          self.log("Serial activate resultCode: " + response.result_code)
          switch (response.result_code) {
            case 'OK':
              self.$router.replace({ name: 'Root' })
              break
            case 'WARN_INPUT_PARAM':
            case 'INFO_INVALID_SERIAL':
              self.message = constants.ERR_INVALID_SERIAL
              break
            case 'INFO_INVALID_ACCESSKEY':
              self.$router.replace({ name: 'Login' })
              break
            default:
              self.message = constants.ERR_UNKNOWN
              break
          }
        })
        .catch(function(err) {
          self.message = constants.ERR_UNKNOWN
        })
    },
    /**
     * 入力値検証
     *
     * @param {Object} event イベントオブジェクト
     */
    validate: function(event){
      // IMEコンポジション中
      if (this.ignore) {
        return
      }
      // カーソル位置を保持
      var selection = event.target.selectionStart
      // アルファベット小文字を含むか
      var isIncludeLowerCase = /[a-z]/.test(event.target.value)
      // アルファベット大文字変換
      event.target.value = event.target.value.toUpperCase()
      // アルファベット小文字を含む場合
      if (isIncludeLowerCase) {
        // カーソル位置調整
        event.target.selectionStart = selection
        event.target.selectionEnd = selection
      }

      // changeイベントがこない場合があるので、ここで設定する
      this.serial = event.target.value
    },
    /**
     * IMEコンポジション完了処理
     *
     * @param {Object} event イベントオブジェクト
     */
    composition: function(event) {
      this.ignore = false
      event.target.value = event.target.value.toUpperCase()

      // changeイベントがこない場合があるので、ここで設定する
      this.serial = event.target.value
    },
    /**
     * フォーマットされたシリアル番号を取得する
     *
     * @return {String} シリアル番号
     */
    getFormattedSerial: function() {
      var firstHyphenIndex = this.serial.indexOf("-")
      if (firstHyphenIndex < 0) {
        return this.serial
      }
      var head = this.serial.substring(0, firstHyphenIndex)
      var tail = this.serial.substring(firstHyphenIndex).replace(/-/g, "")
      return head + "-" + tail
    },
  },
  mounted: function() {
    // Safariのブラウザ縮小時の高さ調整
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1){
      this.fixtHeightForSafariFullWindow()
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/assets/style/login';
</style>



// WEBPACK FOOTER //
// Serial.vue?739b6bce